/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does this include regular contributions?`)
};

const es_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Incluye esto contribuciones regulares?`)
};

const de_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berücksichtigt dies regelmäßige Einzahlungen?`)
};

const nl_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omvat dit regelmatige inbrengsten?`)
};

const fr_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela inclut-il des contributions régulières ?`)
};

const it_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo include contributi regolari?`)
};

const pt_br2_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto inclui contribuições regulares?`)
};

const pt_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto inclui contribuições regulares?`)
};

const ja_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これには定期的な貢献が含まれますか?`)
};

const zh_cp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是否包含定期投入？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq2_q", locale)
	if (locale === "en") return en_cp_faq2_q(inputs)
	if (locale === "es") return es_cp_faq2_q(inputs)
	if (locale === "de") return de_cp_faq2_q(inputs)
	if (locale === "nl") return nl_cp_faq2_q(inputs)
	if (locale === "fr") return fr_cp_faq2_q(inputs)
	if (locale === "it") return it_cp_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq2_q(inputs)
	if (locale === "pt") return pt_cp_faq2_q(inputs)
	if (locale === "ja") return ja_cp_faq2_q(inputs)
	return zh_cp_faq2_q(inputs)
};